import { doc, getDoc } from "firebase/firestore";
import { db } from "../config/firebase";
import { api } from "../config/api";

const isPermissionDenied = (error) => {
  const code = error?.code || "";
  const msg = String(error?.message || "");
  return code === "permission-denied" || msg.toLowerCase().includes("insufficient permissions");
};

export const getSettings = async () => {
    const settingsDocRef = doc(db, 'settings', 'settings');
    try {
        const settingsDocSnap = await getDoc(settingsDocRef);

        if (!settingsDocSnap.exists()) {
            throw new Error("Settings not found");
        }

        return settingsDocSnap.data();
    } catch (error) {
        // If client Firestore is blocked (rules/App Check), fall back to backend (Admin SDK)
        if (isPermissionDenied(error)) {
            try {
                const res = await api.get("/firestore/settings");
                return res.data;
            } catch (proxyError) {
                console.error("Error fetching settings via proxy:", proxyError);
                throw proxyError;
            }
        }

        console.error("Error fetching settings:", error);
        throw error;
    }
};
